import React from 'react';
import cn from 'classnames';

import styles from './integrations.module.scss';

const integrations = [
  { name: 'Revolut', reachable: true },
  { name: 'MailerLite', reachable: true },
  { name: 'OneSignal', reachable: false },
  { name: 'Google Maps', reachable: true },
  { name: 'Kita', reachable: true },
];

const Integrations = () => {
  return (
    <div className={styles.integrationsContainer}>
      <h2>Integracijos</h2>
      <span>Trečiųjų šalių integracijos</span>
      <div className={styles.integrationsContent}>
        {integrations.map(integration => (
          <div key={integration.name} className={styles.integrationsCard}>
            <span className="integration-name">{integration.name}</span>
            <span
              className={cn('integration-status', {
                active: integration.reachable,
              })}
            >
              {integration.reachable ? 'Pasiekiama' : 'Nepasiekiama'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Integrations;
